import { HiringDashboardDataState, HiringDashboardState } from './types';

export const INITIAL_DASHBOARD_DATA_STATE: HiringDashboardDataState = {
  metrics: {
    live_job_request_count: 0,
    draft_job_request_count: 0,
    total_candidates_count: 0,
    screened_candidates_count: 0,
    top_match_candidates_count: 0,
  },
  initialData: null,
};

export const INITIAL_DASHBOARD_STATE: HiringDashboardState = {
  ...INITIAL_DASHBOARD_DATA_STATE,
  metricsLoading: false,
  metricsError: null,
  metricsSuccess: null,

  initialDataLoading: false,
  initialDataError: null,
  initialDataSuccess: null,
};
